// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3lqFY","role":"index-role-ETaOS","btnDetailTriggerArea":"index-btnDetailTriggerArea-3mXa4","btnDetail":"index-btnDetail-jq3F3","active":"index-active-1PG3A"};